export const REQUESTED = 'REQUESTED'
export const PLANNED = 'PLANNED'
export const IN_PROGRESS = 'IN_PROGRESS'
export const COMPLETED = 'COMPLETED'
export const CANCELLED = 'CANCELLED'
export const DELETED = 'DELETED'
